export type CodeSessionPullRequestState = 'open' | 'draft' | 'merged' | 'closed';

/** A pull request's lifecycle state: merged beats closed, closed beats draft, draft beats open. */
export function codeSessionPullRequestState(pullRequest: {
  merged: boolean;
  state: string;
  draft?: boolean;
}): CodeSessionPullRequestState {
  if (pullRequest.merged) {
    return 'merged';
  }
  if (pullRequest.state === 'closed') {
    return 'closed';
  }
  return pullRequest.draft ? 'draft' : 'open';
}

/**
 * GitHub found conflicts between an open (or draft) pull request and its base: only a hydrated
 * `dirty` verdict whose hydration stamp has not been invalidated is used. A closed or merged one
 * has none left to resolve.
 */
export function codeSessionPullRequestHasConflicts(pullRequest: {
  merged: boolean;
  state: string;
  mergeableState: string | null;
  mergeabilityHydratedAt: Date | null;
}): boolean {
  return (
    !pullRequest.merged &&
    pullRequest.state !== 'closed' &&
    pullRequest.mergeabilityHydratedAt !== null &&
    pullRequest.mergeableState?.toLowerCase() === 'dirty'
  );
}
